import React from "react";
import bgImg from "../../assets/bg-img.jpeg"
import { GoogleLogin } from "@react-oauth/google";
import {useNavigate} from "react-router-dom"
const Login = () => {
  const navigate = useNavigate();
  return(
    <div
    className="h-screen w-full  flex flex-col min-h-screen bg-bgImg bg-cover bg-center"
    style={{ backgroundImage: `url(${bgImg})` }}
  >
     <div className="flex-grow flex flex-col justify-center items-center w-full">
        <div className="flex flex-col px-10 py-10 rounded-xl bg-white w-2/5 shadow-lg">
          <h1 className="text-2xl font-bold text-center mb-6">Sign In</h1>
          <p className="text-gray-400 text-center mb-6">
            Sign in with your Google Account
          </p>

          <div onClick={()=>navigate("/admin/dashboard")} className="flex justify-center">
          <GoogleLogin
              // onSuccess={handleSuccess}
              // onError={errorMessage}
              
              // text="continue_with"
              // shape="rectangular"
              // size="large"
            />
          </div>
        </div>
      </div>
    {/* Your content */}
  </div>
  )
};

export default Login;
